import React from 'react';
import axios from 'axios';

export const getDownloadDocument = () => {
  return axios
    .get(`/api/v1/get/external/share/document`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data.data;
    })
    .catch(err => {
      if (err.response.data) {
        return err.response.data;
      } else {
        return err.response;
      }
    });
};

export const documentDownloadLogin = (uid: string, password: string) => {
  const data = { uid, password };
  return axios
    .post('/api/v1/document/external/share/login', data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      return err.response;
    });
};

export const downloadDocument = (document_id: number) => {
  const data = { document_id };
  return axios
    .post('/api/v1/download/document', data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      return err.response;
    });
};

export const updateSendStatus = () => {
  return axios
    .post('/api/v1/document/external/share/update/status', {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      return err.response;
    });
};
